export enum BillingActionTypes {
  READ_BILLING_REQUEST = 'Billing.READ_BILLING_REQUEST',
  READ_BILLING_SUCCESS = 'Billing.READ_BILLING_SUCCESS',
  READ_BILLING_FAILURE = 'Billing.READ_BILLING_FAILURE',
}
